import { render, staticRenderFns } from "./SystemCallNumSinglePage.vue?vue&type=template&id=82fa5a08&scoped=true&"
import script from "./SystemCallNumSinglePage.vue?vue&type=script&lang=js&"
export * from "./SystemCallNumSinglePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fa5a08",
  null
  
)

export default component.exports